export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-pink-100 via-lavender-100 to-sky-100">
      {/* Floating Bubbles Animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-gradient-to-br from-pink-200/30 to-lavender-200/30 animate-float"
            style={{
              width: `${Math.random() * 60 + 20}px`,
              height: `${Math.random() * 60 + 20}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${Math.random() * 10 + 10}s`,
            }}
          />
        ))}
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-300 to-lavender-300 text-gray-800 px-4 py-2 rounded-full mb-6 animate-bounce shadow-lg text-sm">
            <i className="ri-quill-pen-line text-base"></i>
            <span className="font-semibold whitespace-nowrap">Award-Winning Children's Author</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-pink-400 via-lavender-400 to-sky-400 bg-clip-text text-transparent leading-tight">
            L.J. Boydston
          </h1>
          
          <p className="text-2xl md:text-3xl text-gray-700 mb-6 font-medium">
            Children's Book Author ✨
          </p>

          <p className="text-base md:text-lg text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Discover magical stories that spark imagination, teach valuable lessons, 
            and create unforgettable adventures for young readers! 📚💝
          </p>

          {/* Book Covers */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            <div className="group cursor-pointer transform transition-all duration-300 hover:scale-110 animate-wiggle">
              <img
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/6f21f45f1a49d0b3e0daa34848460ff1.jpeg"
                alt="March of the Ants Book Cover"
                className="w-48 h-64 object-cover rounded-2xl shadow-2xl border-4 border-white"
              />
            </div>
            <div className="group cursor-pointer transform transition-all duration-300 hover:scale-110 animate-wiggle" style={{ animationDelay: '0.2s' }}>
              <img
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/add5b462c93d67b33c29548e56c8736b.jpeg"
                alt="What Is that Smell? Book Cover"
                className="w-48 h-64 object-cover rounded-2xl shadow-2xl border-4 border-white"
              />
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://www.amazon.com/stores/L-J-Boydston/author/B0GFBQXQXQ"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 bg-gradient-to-r from-pink-300 to-pink-400 text-gray-800 px-6 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-book-open-line text-lg group-hover:animate-bounce"></i>
              View All Books
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
            </a>
            <a
              href="https://www.amazon.com/March-Ants-L-J-Boydston/dp/1969865253/ref=sr_1_3?dib=eyJ2IjoiMSJ9.azebjqgrJvD2tJYp4FhromrOoSglaQ6YH6554-TBtizKMAupPXEjh-5pNNlQCPIf.82nf9cbaBtObFr-RnuADz4PvTiQ-DRXf5uj--dYS0lc&dib_tag=se&qid=1769006752&refinements=p_27%3AL+J+Boydston&s=books&sr=1-3&text=L+J+Boydston"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 bg-white text-pink-500 px-6 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 border-2 border-pink-300 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-compass-3-line text-lg group-hover:rotate-180 transition-transform duration-500"></i>
              Explore the Collection
            </a>
          </div>

          {/* Fun Stats */}
          <div className="mt-12 grid grid-cols-3 gap-4 max-w-2xl mx-auto">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-lg transform hover:scale-105 transition-all duration-300">
              <div className="text-2xl font-bold text-pink-400 mb-1">4+</div>
              <div className="text-xs text-gray-600">Books Published</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-lg transform hover:scale-105 transition-all duration-300">
              <div className="text-2xl font-bold text-lavender-400 mb-1">20+</div>
              <div className="text-xs text-gray-600">Years Writing</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-lg transform hover:scale-105 transition-all duration-300">
              <div className="text-2xl font-bold text-sky-400 mb-1">∞</div>
              <div className="text-xs text-gray-600">Happy Readers</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-pink-400"></i>
      </div>
    </section>
  );
}
